import { API, graphqlOperation } from '../utils/amplifyCompat';
import * as custom_queries from '../customgraphql/queries';
import * as custom_mutations from '../customgraphql/mutations';

// Stripe create customer and subscribe annual plan
// -----------------------------------------------------------------------------
export function stripeCreateMember(stripeData) {
	return async () => {
		try {
			const data = await API.graphql(
				graphqlOperation(custom_mutations.gnjAmplifyStripeCreateMember, stripeData)
			);
			return JSON.parse(data.data.gnjAmplifyStripeCreateMember);
		} catch (err) {
			console.log("error Stripe user sign up: ", err);
			// The Lambda throws on failure (declined card, already a member, ...): show its message.
			return { error: err?.errors?.[0]?.message || err?.message || "Something went wrong. Please try again." };
		}
	};
}

// Finish a subscribe attempt whose card needed 3-D Secure, after the page ran the challenge.
// -----------------------------------------------------------------------------
export function stripeConfirmMember({ subscriptionId, attemptId }) {
	return async () => {
		try {
			const data = await API.graphql(
				graphqlOperation(custom_mutations.gnjAmplifyStripeConfirmMember, { subscriptionId, attemptId })
			);
			return JSON.parse(data.data.gnjAmplifyStripeConfirmMember);
		} catch (err) {
			console.log("error Stripe confirm member: ", err);
			return { error: err?.errors?.[0]?.message || err?.message || "Something went wrong. Please try again." };
		}
	};
}

// Stripe get customer information
// -----------------------------------------------------------------------------
export function stripeGetCustomerInfo(stripeCustomerId) {
	return async () => {
		try {
			const data = await API.graphql(
				graphqlOperation(custom_queries.gnjAmplifyStripeGetCustomerInfo, { stripeCustomerId: stripeCustomerId })
			);
			return JSON.parse(data.data.gnjAmplifyStripeGetCustomerInfo);
		} catch (err) {
			console.log("error Stripe get customer info: ", err);
		}
	};
}

// Stripe update customer credit card
// -----------------------------------------------------------------------------
export function updateCustomerCreditCard(stripeCustomerId, stripeToken) {
	return async () => {
		try {
			const data = await API.graphql(
				graphqlOperation(custom_mutations.gnjAmplifyupdateCustomerCreditCard, { stripeCustomerId: stripeCustomerId, stripeToken: stripeToken })
			);
			return JSON.parse(data.data.gnjAmplifyupdateCustomerCreditCard);
		} catch (err) {
			console.log("error Stripe update customer credit card: ", err);
		}
	};
}

// Stripe update customer information
// -----------------------------------------------------------------------------
export function updateStripeCustomerInfo(customerData) {
	return async () => {
		try {
			const data = await API.graphql(
				graphqlOperation(custom_mutations.gnjAmplifyStripeUpdateCustomer, customerData)
			);
			return JSON.parse(data.data.gnjAmplifyStripeUpdateCustomer);
		} catch (err) {
			console.log("error Stripe update customer credit card: ", err);
		}
	};
}

// Stripe retrieve coupon code
// -----------------------------------------------------------------------------
export function stripeGetCouponCode(stripeCouponId) {
	return async () => {
		try {
			const data = await API.graphql(
				graphqlOperation(custom_mutations.gnjAmplifyStripeGetCouponCode, { stripeCouponId: stripeCouponId })
			);
			return JSON.parse(data.data.gnjAmplifyStripeGetCouponCode);
		} catch (err) {
			console.log("error Stripe update customer credit card: ", err);
			const errorMsg = (err && err.errors[0] && err.errors[0].message) || 'No coupon code found';
			return {error: errorMsg};
		}
	};
}

// Stripe cancel membership
// -----------------------------------------------------------------------------
// reason/comment: the optional "why are you leaving?" answers, sent only when cancelling.
export function stripeCancelMembership(stripeSubscriptionId, cancel, { reason, comment } = {}) {
	return async () => {
		try {
			const variables = { stripeSubscriptionId: stripeSubscriptionId, cancel: cancel };
			if (cancel && reason) variables.reason = reason;
			if (cancel && comment) variables.comment = comment;
			const data = await API.graphql(
				graphqlOperation(custom_mutations.gnjAmplifyStripeCancelMembership, variables)
			);
			return JSON.parse(data.data.gnjAmplifyStripeCancelMembership);
		} catch (err) {
			console.log("error Stripe update cancellation status: ", err);
		}
	};
}

// User back up journals
// -----------------------------------------------------------------------------
export function userBackUpJournals(username, deleteBackup) {
	return async () => {
		try {
			const data = await API.graphql(
				graphqlOperation(custom_queries.gnjAmplifyuserBackUpJournals, {username, deleteBackup})
			);
			return JSON.parse(data.data.gnjAmplifyuserBackUpJournals);
		} catch (err) {
			console.log("error userBackUpJournals: ", err);
		}
	};
}